// extracted by mini-css-extract-plugin
export default {"SellPage":"styles_SellPage__DDyCk","container":"styles_container__677yz","leftBox":"styles_leftBox__JnuGJ","dial":"styles_dial__wkiDM","rightBox":"styles_rightBox__viwxH"};